// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__23sEK","title":"Info_title__2qKJ7","selects":"Info_selects__2zUYV","requiredAsterisk":"Info_requiredAsterisk__2TQ2R"};